import { Progress } from "./progress";
import { usePage } from "@tree-company/tree-query";
import clsx from "clsx";
import { useContext, useEffect, useMemo, useRef } from "react";
import { LocaleContext } from "../app";

function stepForPageKey(key) {
  if (key.startsWith("comment")) {
    return 1;
  } else if (key === "name") {
    return 2;
  } else if (key === "sociodemo") {
    return 3;
  } else if (key === "like") {
    return 4;
  } else if (key === "optin") {
    return 5;
  }
}

export function PageComponent({
  handleSave,
  page,
  children,
  onPreviousPage,
  className,
}) {
  const { title, description, htmlAttributes, key } = usePage(page);
  const elementRef = useRef();
  const { translate } = useContext(LocaleContext);
  const step = useMemo(() => stepForPageKey(key), [key]);
  const statementName = useMemo(
    () => page.treesponse.getAnswer("statement"),
    [key],
  );

  // Make sure the browsers back button has the same effect as our back button
  useEffect(() => {
    // If the previous history entry was a string, we already track history within the form
    // in that case, we can use `replaceState`
    // If not, we need to use `pushState` so that we can distinguish our history states from react router dom
    if (typeof window.history.state === "string") {
      window.history.replaceState(key, "", window.location.toString());
    } else {
      window.history.pushState(key, "", window.location.toString());
    }

    const goBack = (event) => {
      event.preventDefault();
      onPreviousPage();
    };
    window.addEventListener("popstate", goBack, { once: true });
    return () => window.removeEventListener("popstate", goBack, { once: true });
  }, [key]);

  useEffect(() => {
    // If our context has defined fathom, we send fake pages with the current step of the form
    if (window.fathom) {
      const locationWithKey = new URL(window.location);
      locationWithKey.pathname += `/${key}`;
      window.fathom.trackPageview({ url: locationWithKey.toString() });
    }
  }, [key]);

  useEffect(() => {
    if (elementRef.current) {
      const { top, left } = elementRef.current.getBoundingClientRect();
      window.scrollTo({ top, left });
    }
  }, [key, elementRef]);

  return (
    <main className={clsx("app__container", className)} ref={elementRef}>
      <div className="card">
        <form
          action=""
          className={clsx("survey", htmlAttributes.class)}
          onSubmit={handleSave}
        >
          <Progress
            title={translate(["statements", statementName, "shortName"])}
            onBackButton={onPreviousPage}
            step={step}
          />
          {(title || description) && (
            <div className="survey__intro">
              {title && <h1 className="survey__title">{title}</h1>}
              {description && <p className="survey__text">{description}</p>}
            </div>
          )}

          {children}

          {page.settings.showNext !== false && (
            <button className="survey__action">
              {translate("general.next_page")}
            </button>
          )}
        </form>
      </div>
      {key == "next" && (
        <a href={translate("next.other_topic.url")} className="link">
          {translate("next.other_topic.text")}
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="currentColor"
            className="card__link-icon"
          >
            <path d="M15.2188 11.25H0V8.75H15.2188L8.21875 1.75L10 0L20 10L10 20L8.21875 18.25L15.2188 11.25Z" />
          </svg>
        </a>
      )}
    </main>
  );
}
